import comp from "./UIBaseContentEditable";
export default comp;
